import React, { useState, useRef, useEffect } from "react";
import { Menu, X } from "lucide-react";
import "./NavBar.css";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const smoothScroll = (targetEl, duration = 1000) => {
    const targetPosition =
      targetEl.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    };

    const easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    requestAnimationFrame(animation);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!isMenuOpen) return;
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    const handleKey = (e) => {
      if (e.key === "Escape") setIsMenuOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    document.addEventListener("keydown", handleKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [isMenuOpen]);

  return (
    <div className="nav-container">
      <nav className="navbar">
        <div className="nav-content">
          <Link to={"/"} className="nav-logo">
            <div className="logo">
              attol<span className="logo-i">i</span>
            </div>
          </Link>

          <div className="desktop-menu">
            <Link to="/about" className="nav-link">
              About
            </Link>
            <Link to="/services-for-accountants" className="nav-link">
              Services
            </Link>
            <Link to="/resources" className="nav-link">
              Resources
            </Link>

            <Link to="/contact">
              <button className="nav-contact-btn">Get Started</button>
            </Link>
          </div>

          <button
            ref={buttonRef}
            onClick={toggleMenu}
            className="mobile-menu-btn"
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            title={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="mobile-menu" ref={menuRef}>
            <Link
              to="/about"
              className="nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/services-for-accountants"
              className="nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </Link>
            <Link
              to="/resources"
              className="nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Resources
            </Link>

            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
              <button className="nav-contact-btn mobile">Get Started</button>
            </Link>
          </div>
        )}
      </nav>
    </div>
  );
};

export default NavBar;
